<template>
    <div class="group flex items-baseline gap-4">
        <h1 class="text-[28px] font-bold">
            {{ classroom.name }}
        </h1>

        <new-modal
            title="Edit classroom name"
            size="xl"
            ref="changeClassroomNameModal"
        >
            <template #trigger>
                <div class="link hidden text-[14px] group-hover:inline">
                    Edit name
                </div>
            </template>
            <template #content>
                <div class="text-[15px] text-gray-750">
                    Change the name of this classroom
                </div>
                <form @submit.prevent="submitForm">
                    <div class="">
                        <FormInput
                            name="classroom_name"
                            v-model="form.classroomName"
                        ></FormInput>
                    </div>
                    <div class="">
                        <hr />
                        <div class="mt-4 flex items-center justify-end">
                            <div class="btn btn-transparent" @click="cancel()">
                                Cancel
                            </div>
                            <button
                                :class="
                                    'btn' +
                                    ' ' +
                                    (form.isDirty
                                        ? 'btn-primary'
                                        : 'btn-disabled')
                                "
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </form>
            </template>
        </new-modal>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal.vue";
import FormInput from "@/Components/FormInput.vue";

export default {
    name: "GroupClassroomName",
    components: { FormInput, NewModal },
    props: {
        classroom: {},
    },
    data() {
        return {
            form: this.$inertia.form({
                classroomName: this.classroom.name,
            }),
        };
    },
    methods: {
        submitForm() {
            let vm = this;

            this.$inertia.get(
                route("group.classroom.update-name", {
                    classroom: this.classroom.id,
                }),
                {
                    classroom_name: this.form.classroomName,
                }
            );
        },
        cancel() {
            this.form.reset;
            this.$refs.changeClassroomNameModal.closeModal();
        },
    },
};
</script>
